export type PersonalDetails = {
	birthDate: string
	address: {
		zipCode: string
		houseNumber: string | null
		houseNumberAddition: string | null
	}
}

export enum DrivenDistancePerYear {
	LessThan7500 = 'LESS_THAN_7500',
	Between7500And15000 = 'BETWEEN_7500_AND_15000',
	Between15000And25000 = 'BETWEEN_15000_AND_25000',
	MoreThan25000 = 'MORE_THAN_25000',
}

export enum InsuranceCoverage {
	Simple = 'SIMPLE',
	LimitedCasco = 'LIMITED_CASCO',
	FullCasco = 'FULL_CASCO',
}
